module.exports = "<page-topbar></page-topbar>\r\n<page-header></page-header>\r\n\r\n<div class=\"main_area\">\r\n\t<div [hidden]=\"! photoService.showFilter\" class=\"leftsidebar_area\">\r\n\t\t<panel-filter></panel-filter></div>\r\n\t<div class=\"result_area\"><panel-result></panel-result></div>\r\n</div>\r\n<page-footer></page-footer>\r\n<!--\r\n <router-outlet></router-outlet>\r\n  -->\r\n"


//////////////////
// WEBPACK FOOTER
// ./src/app/html/pageContent.html
// module id = 683
// module chunks = 1